import type { AccessToken } from "@okta/okta-auth-js";

export async function authenticatedJsonHeaders(): Promise<
  Record<string, string>
> {
  const { oktaAuthInstance } = await import("@/plugins/oktaPlugin");
  const accessToken = (await oktaAuthInstance?.tokenManager.get(
    "accessToken",
  )) as AccessToken | undefined;
  if (!accessToken?.accessToken) {
    throw new Error("A valid access token is required.");
  }
  return {
    Authorization: `Bearer ${accessToken.accessToken}`,
    "Content-Type": "application/json",
  };
}
